import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { inject, observer } from 'mobx-react'

import { Link } from 'react-router'

import StateIcon from '../../shared/components/StateIcon'
import Icon from '../../shared/components/Icon'

@inject('auth') @observer
export default class ListEntry extends Component {

  static propTypes = {
    auth: PropTypes.shape({
      acs: PropTypes.shape({
        isAuthorized: PropTypes.func.isRequired
      }).isRequired
    }).isRequired,
    editable: PropTypes.bool.isRequired,
    guidedTour: PropTypes.object.isRequired,
    showMuseum: PropTypes.bool
  }

  render() {
    const {
      auth, guidedTour, editable, showMuseum
    } = this.props
    const linkTo = editable
      ? `/guidedTour/${guidedTour.id}/edit`
      : `/guidedTour/${guidedTour.id}`
    const adminToolsLinkTo = `/guidedTour/${guidedTour.id}/admin`

    const isAdmin = auth.acs.isAuthorized('ADMIN')
    const isSuperAdmin = auth.acs.isAuthorized('SUPERADMIN')

    return (
      <li className="guidedTour iconized">
        <div>
          <StateIcon
            item={guidedTour}
          />
          <Link to={linkTo}>
            {guidedTour.title}
&nbsp;
            {showMuseum ? `(${guidedTour.museum.name})` : null}
            {isAdmin && !guidedTour.isLive
              ? <strong>&nbsp;[Keine Live-Version]</strong>
              : null}
          </Link>
          <span className="tools">
            <Link to={linkTo}>
              <Icon
                className="tool-icon"
                size={18}
                name={`${editable ? 'pencil' : 'envelope'}-turquoise`}
              />
            </Link>
            {isSuperAdmin
              ? (
                <Link to={adminToolsLinkTo}>
                  <Icon
                    className="tool-icon"
                    size={18}
                    name="pencil"
                  />
                </Link>
              )
              : null}
          </span>
        </div>
      </li>
    )
  }

}



// WEBPACK FOOTER //
// ./src/guided-tour/components/ListEntry.js